const TableHeader = ({ title }: { title: string }) => {
  return <div style={{ whiteSpace: "nowrap" }}>{title}</div>;
};

export default TableHeader;
